/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminNotification,
  AdminV1OrganizationsAdminNotificationsListParams,
  ClearAllNotificationsResponse,
  PaginatedAdminNotificationList,
  ReadAllNotificationsResponse,
  UnreadNotificationCountResponse
} from '.././model';

import adminV1OrganizationsAdminNotificationsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAdminNotificationsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAdminNotificationsReadCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAdminNotificationsClearAllCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAdminNotificationsReadAllCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsAdminNotificationsUnreadCountRetrieveMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Admin notification endpoints.

list: Returns notifications targeted at the current user or all org admins.
retrieve: Get a single notification.
 * @summary Admin notification endpoints.
 */
export const adminV1OrganizationsAdminNotificationsList = (
    organizationId: number,
    params?: AdminV1OrganizationsAdminNotificationsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsAdminNotificationsListMutator<PaginatedAdminNotificationList>>,) => {
      return adminV1OrganizationsAdminNotificationsListMutator<PaginatedAdminNotificationList>(
      {url: `/api/admin/v1/organizations/${organizationId}/admin-notifications/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Admin notification endpoints.

list: Returns notifications targeted at the current user or all org admins.
retrieve: Get a single notification.
 * @summary Admin notification endpoints.
 */
export const adminV1OrganizationsAdminNotificationsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsAdminNotificationsRetrieveMutator<AdminNotification>>,) => {
      return adminV1OrganizationsAdminNotificationsRetrieveMutator<AdminNotification>(
      {url: `/api/admin/v1/organizations/${organizationId}/admin-notifications/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mark a single notification as read.
 * @summary Mark a single notification as read.
 */
export const adminV1OrganizationsAdminNotificationsReadCreate = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsAdminNotificationsReadCreateMutator<AdminNotification>>,) => {
      return adminV1OrganizationsAdminNotificationsReadCreateMutator<AdminNotification>(
      {url: `/api/admin/v1/organizations/${organizationId}/admin-notifications/${id}/read/`, method: 'POST'
    },
      options);
    }
  /**
 * Clear all notifications for the current user. Deletes user-targeted notifications and dismisses org-wide ones.
 * @summary Clear all notifications for the current user. Deletes user-targeted notifications and dismisses org-wide ones.
 */
export const adminV1OrganizationsAdminNotificationsClearAllCreate = (
    organizationId: number,
 options?: SecondParameter<typeof adminV1OrganizationsAdminNotificationsClearAllCreateMutator<ClearAllNotificationsResponse>>,) => {
      return adminV1OrganizationsAdminNotificationsClearAllCreateMutator<ClearAllNotificationsResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/admin-notifications/clear-all/`, method: 'POST'
    },
      options);
    }
  /**
 * Mark all unread notifications as read for the current user.
 * @summary Mark all unread notifications as read for the current user.
 */
export const adminV1OrganizationsAdminNotificationsReadAllCreate = (
    organizationId: number,
 options?: SecondParameter<typeof adminV1OrganizationsAdminNotificationsReadAllCreateMutator<ReadAllNotificationsResponse>>,) => {
      return adminV1OrganizationsAdminNotificationsReadAllCreateMutator<ReadAllNotificationsResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/admin-notifications/read-all/`, method: 'POST'
    },
      options);
    }
  /**
 * Lightweight endpoint for polling — returns just the unread count.
 * @summary Lightweight endpoint for polling — returns just the unread count.
 */
export const adminV1OrganizationsAdminNotificationsUnreadCountRetrieve = (
    organizationId: number,
 options?: SecondParameter<typeof adminV1OrganizationsAdminNotificationsUnreadCountRetrieveMutator<UnreadNotificationCountResponse>>,) => {
      return adminV1OrganizationsAdminNotificationsUnreadCountRetrieveMutator<UnreadNotificationCountResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/admin-notifications/unread-count/`, method: 'GET'
    },
      options);
    }
  export type AdminV1OrganizationsAdminNotificationsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAdminNotificationsList>>>
export type AdminV1OrganizationsAdminNotificationsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAdminNotificationsRetrieve>>>
export type AdminV1OrganizationsAdminNotificationsReadCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAdminNotificationsReadCreate>>>
export type AdminV1OrganizationsAdminNotificationsClearAllCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAdminNotificationsClearAllCreate>>>
export type AdminV1OrganizationsAdminNotificationsReadAllCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAdminNotificationsReadAllCreate>>>
export type AdminV1OrganizationsAdminNotificationsUnreadCountRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsAdminNotificationsUnreadCountRetrieve>>>
